import { ApplicationInitGuard } from '@aipb/gulliver/util-app';
import { Injectable } from '@angular/core';
import { ZipManagerEnvService } from '@aipb/gulliver/zip-manager/env';

@Injectable()
export class ZipManagerInitGuard extends ApplicationInitGuard {
  constructor(protected zipManagerEnv: ZipManagerEnvService) {
    super('zip-manager', zipManagerEnv);
  }
}
